import type { BeneficialOwnerResponse } from '@gcv/shared';

export const getMostRecentCertification = (owner: BeneficialOwnerResponse) => {
  return Object.values(owner.template_result_map)
    .flatMap((templateResult) =>
      templateResult.certification_data ? [templateResult.certification_data] : []
    )
    .sort((a, b) => b.date.localeCompare(a.date))[0];
};
